/**
 * UnitSelection function allows users to select territorial units from a filtered list.
 * 
 * @param {Object} props - The properties object.
 * @param {Function} props.setTerrUnit - Function to set the selected territorial units.
 * 
 * @returns {JSX.Element} The rendered UnitSelection function.
 * 
 * This function uses the `StoreTerrUnit` hook to fetch and filter territorial units.
 * It filters the response to include only units with levels 0, 1, 2, or 3, excluding 'EU28' and 'EU27'.
 * The `AutocompleteSearch` function is used to provide a search and selection interface.
 * The `resultTerrUnit` function is called when a selection is made, updating the selected territorial units.
 */

import { StoreTerrUnit } from '../../hooks/store';
import { TerrUnitArray } from '@front-ends/common/src/utils/types/TerrUnitTypes';
import AutocompleteSearch from '@front-ends/common/src/components/app/AutocompleteSearch';
import { useTranslation } from 'react-i18next';

export default function UnitSelection({setTerrUnit}:any) {
  
  const { t } = useTranslation();
  
  const {search, response} = StoreTerrUnit();
  const filteredResponse = response?.filter(i => i.level === 3 || i.level === 2 || i.level === 1 || i.level === 0).filter(i => i.key !== 'EU28' && i.key !== 'EU27') ?? [];
  var projectTerrUnit: string[] = []

  function resultTerrUnit(value: TerrUnitArray[]) {
    setTerrUnit(value);
    value.forEach(t => {
      projectTerrUnit.push(t?.name);
    })
  }

  return (
    <AutocompleteSearch 
      optionsLabel={"name"}
      optionsName={""}
      keyLabel={"id"}
      searchStore={search}
      responseStore={filteredResponse}
      addResultFunction={resultTerrUnit}
      displayLabel={t("terr-unit-context")}
      customSearchItems={null}
      multipleResponse={true}
    />
  );
}